import React from "react";
import { useCurrency } from "../lib/currency-context";
import { cn } from "../lib/utils";

const OPTIONS = [
  { code: "CZK", label: "K\u010d" },
  { code: "EUR", label: "\u20ac" },
];

export const CurrencySwitcher = ({ className }) => {
  const { currency, setCurrency } = useCurrency();
  return (
    <div
      role="group"
      aria-label="Currency switcher"
      data-testid="currency-switcher"
      className={cn("inline-flex items-center rounded-full border border-border bg-card p-0.5", className)}
    >
      {OPTIONS.map((o) => (
        <button
          key={o.code}
          type="button"
          data-testid={`currency-option-${o.code}`}
          onClick={() => setCurrency(o.code)}
          aria-pressed={currency === o.code}
          className={cn(
            "px-2.5 py-1 text-xs font-semibold rounded-full transition-colors duration-150",
            currency === o.code ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
};
